import React from "react";

const MediumHeader = ({
  className,
  ...rest
}: React.DetailedHTMLProps<
  React.HTMLAttributes<HTMLDivElement>,
  HTMLDivElement
>) => <div className={`${className} text-3xl text-secondary`} {...rest} />;

export default MediumHeader;
